import bowser from 'bowser'

export default {
  name() {
    return bowser.name
  },

  version() {
    return bowser.version
  },

  desktop() {
    return (bowser.mobile === 'undefined') && (bowser.tablet === 'undefined')
  },

  mobile() {
    return (bowser.mobile !== 'undefined')
  },

  tablet() {
    return (bowser.tablet !== 'undefined')
  },

  upgrade() {
    let url = 'http://www.google.com/chrome'
    if (bowser.msie || bowser.msedge) url = 'http://www.microsoft.com/download/internet-explorer.aspx'
    else if (bowser.firefox) url = 'http://www.mozilla.org/firefox'
    else if (bowser.safari) url = 'http://www.mozilla.org/firefox'
    window.location.replace(url)
  },

  support() {
    console.log(bowser.name+' '+bowser.version)
    if (bowser.chrome && bowser.version >= 45) return true
    else if (bowser.msie && bowser.version >= 10) return true
    else if (bowser.msedge && bowser.version >= 12) return true
    else if (bowser.firefox && bowser.version >= 38) return true
    else if (bowser.safari && bowser.version >= 9) return true
    else if (bowser.adroid && bowser.version >= 4.4) return true
    else if (bowser.opera && bowser.version >= 30) return true
    return false
  }

}



// WEBPACK FOOTER //
// ./src/lib/agent.js